<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <MarketSegmentRadioFormPart @result="onResult" @change="onChange" />
      <h2 class="form-modal__part-title">
        {{ $t('steps.typeOfAssignment') }}
      </h2>
      <ServiceRadioFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import MarketSegmentRadioFormPart from 'chimera/all/components/form/parts/marketSegment/MarketSegmentRadioFormPart'
import ServiceRadioFormPart from 'chimera/windowFrames/components/form/parts/service/ServiceRadioFormPart.fr'
import NextStep from '~/pages/quotes-requests/vos-coordonnees'

export default {
  name: 'ServiceTypeFormStep',

  components: {
    MarketSegmentRadioFormPart,
    ServiceRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
